import config from '../config';

export async function apiRequest<T>(
path: string,
  options: RequestInit = {}
): Promise<T> {
  const baseUrl = config.apiBaseUrl + config.basePath;
  const token = localStorage.getItem('authToken');

  const response = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`API Error (${response.status}): ${errorText}`);
  }

  return response.json();
}
export async function fetchRepos() {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/repos`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) throw new Error('Failed to fetch repos');
  return res.json();
}

export async function choosePlan(plan: string): Promise<void> {
  return apiRequest('/choose-plan', {
    method: 'POST',
    body: JSON.stringify({ plan })
  });
}

export async function selectPlan(planId: string) {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${config.apiBaseUrl}${config.basePath}/select-plan`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ plan_id: planId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to select plan: ${response.status}`);
  }

  return await response.json();
}

export async function generateTests({
  repoUrl,
  language,
  framework
}: {
  repoUrl: string;
  language: string;
  framework?: string;
}) {
  const token = localStorage.getItem("authToken");

  const provider = repoUrl.includes("github.com")
    ? "github"
    : repoUrl.includes("gitea")
    ? "gitea"
    : "unknown";

  const res = await fetch(`${config.apiBaseUrl}${config.apiBaseUrl}/generate/tests`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({
      repo_url: repoUrl,
      language,
      framework,
      provider,
    }),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error?.error || "Failed to generate tests");
  }

  return res.json(); // { pr_url }
}

export async function generatePipeline(payload: any): Promise<{ pr_url: string }> {
  const token = localStorage.getItem("authToken");
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/generate/pipeline`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text();
    try {
      const json = JSON.parse(text);
      throw new Error(json?.error || "Unknown error");
    } catch {
      throw new Error(text);
    }
  }

  return res.json();
}
export async function fetchUserProviders(): Promise<{ connected: string[] }> {
  const token = localStorage.getItem('authToken');
  console.log('Fetching user providers with token:', token);
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/user/providers`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log('Fetching user providers:', res);
  if (!res.ok) throw new Error('Failed to fetch user providers');
  return res.json();
}
export async function fetchRecentPipelines(): Promise<any[]> {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/user/pipelines`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to fetch recent pipelines');
  return res.json().pipelines || [];
}
export async function fetchRecentTests(): Promise<any[]> {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/user/tests`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to fetch recent tests');
  return res.json().tests || [];
}
export async function fetchCachedRepos(locked?: boolean): Promise<any[]> {
  const token = localStorage.getItem('authToken');
  const args = locked !== undefined ? `?locked=${locked}` : '';
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/user/repos${args}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to fetch locked repos');
  console.log('Fetched cached repos:', res);
  const json = await res.json();
  console.log("fetchCachedRepos json response:", json);
  return json.repos || [];
}
export async function fetchPendingPRs(): Promise<any[]> {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${config.apiBaseUrl}${config.basePath}/prs/pending`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to fetch pending PRs');
  return res.json();
}
